import React from 'react'
import { connect } from 'react-redux'

import Button from 'components/Button'
import TabContentPersonal from './TabContentPersonal'
import TabContentAccess from './TabContentAccess'
import ModalAddUsersToGroups from '../ModalAddUsersToGroups'

import actions from 'store/actions'
import {
  SETTINGS_PAGINATION,
  CARD_USER_TABS,
  MODAL_ALERT_TYPES,
} from 'utils/consts'

import closeBtn from 'assets/images/close.svg'

class ModalCardUser extends React.Component {
  constructor() {
    super()

    this.state = {
      activeTab: CARD_USER_TABS.PERSONAL,
      photo: [],
      uploadPhoto: null,
      deletedPhoto: [],

      isOpenModalAddUsersToGroups: false,
    }
  }

  /**
   * @param {String} activeTab
   */
  handleChangeTab = activeTab => {
    this.setState({ activeTab })
  }

  /**
   * @param {Object} uploadPhoto
   */
  changeUploadPhoto = uploadPhoto => {
    this.setState({ uploadPhoto })
  }

  /**
   * @param {Array} deletedPhoto
   */
  changeDeletedPhoto = deletedPhoto => {
    this.setState({ deletedPhoto })
  }

  /**
   * @return {Boolean|Undefined}
   */
  createUser = async () => {
    this.props.closeModal()

    try {
      const { id } = await this.props.createUser();

      if (this.state.uploadPhoto) {
        const data = new FormData()
        data.append('employee_id', id)
        data.append('file', this.state.uploadPhoto)

        await this.props.addUserPhoto(data)
      }
      await this.props.fetchUsers({
        count: SETTINGS_PAGINATION.COUNT_PER_PAGE,
        page: SETTINGS_PAGINATION.PAGE_NUMBER,
      })
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  /**
   * @return {Boolean|Undefined}
   */
  editUser = async () => {
    const { pageNumber, itemsPerPage } = this.props
    const { uploadPhoto, deletedPhoto } = this.state
    this.props.closeModal()

    try {
      if (uploadPhoto) {
        const data = new FormData()

        data.append('employee_id', this.props.user.id)
        data.append('file', uploadPhoto)
        await this.props.addUserPhoto(data)
      }

      if (deletedPhoto.length) {
        await this.props.removeUserPhoto(deletedPhoto)
      }
      await this.props.fetchUsers({
        count: itemsPerPage,
        page: pageNumber,
      })
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  /**
   * @param {Object} group
   */
  removeGroup = async group => {
    const data = {
      employee_id: this.props.user.id,
      access_object_id: group.access_object,
      group_id: group.id,
    }
    const { itemsPerPage, pageNumber } = this.props

    try {
      await this.props.removeGroup(data)
      await this.props.fetchUsers({
        count: itemsPerPage,
        page: pageNumber,
      })
      await this.props.fetchGroups({
        count: itemsPerPage,
        page: pageNumber,
      })
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  changeVisibillityModalAddUsersToGroups = () => {
    this.setState(prevState => ({
      isOpenModalAddUsersToGroups: !prevState.isOpenModalAddUsersToGroups,
    }))
  }

  render() {
    const { mode, user } = this.props
    const { activeTab, isOpenModalAddUsersToGroups } = this.state

    if (mode === 'create') {
      this.title = 'Добавление сотрудника'
      this.buttonText = 'Добавить'

      this.action = this.createUser
    } else {
      this.title = 'Карточка сотрудника'
      this.buttonText = 'Сохранить'

      this.photoList = user.photo.length ? user.photo : []
      this.groups = user.groups
      this.action = this.editUser
    }

    return (
      <>
        <div className='modal-overlay'>
          <div className='modal modal--sm'>
            <div className='modal__header'>
              <p className='modal__title'>{this.title}</p>
              <Button
                className='button--icon'
                icon={true}
                iconPicture={closeBtn}
                action={this.props.closeModal}
              />
            </div>

            <div className='modal__content'>
              {mode !== 'create' && (
                <div className='modal__nav'>
                  <ul>
                    <li
                      className={
                        activeTab === CARD_USER_TABS.PERSONAL ? 'active' : ''
                      }
                      onClick={() =>
                        this.handleChangeTab(CARD_USER_TABS.PERSONAL)
                      }>
                      Данные
                    </li>
                    <li
                      className={
                        activeTab === CARD_USER_TABS.ACCESS ? 'active' : ''
                      }
                      onClick={() =>
                        this.handleChangeTab(CARD_USER_TABS.ACCESS)
                      }>
                      Доступ
                    </li>
                  </ul>
                </div>
              )}

              {activeTab === CARD_USER_TABS.PERSONAL && (
                <TabContentPersonal
                  changeUploadPhoto={this.changeUploadPhoto}
                  changeDeletedPhoto={this.changeDeletedPhoto}
                  photoList={this.photoList}
                />
              )}
              {activeTab === 'access' && (
                <TabContentAccess
                  removeGroup={this.removeGroup}
                  openModalAlert={this.props.openModalAlert}
                  groups={this.groups}
                />
              )}
            </div>

            <div
              className={`modal__bottom${
                !(activeTab !== CARD_USER_TABS.PERSONAL)
                  ? ' modal__bottom--right'
                  : ''
              }`}>
              {activeTab !== CARD_USER_TABS.PERSONAL && (
                <Button
                  title='Добавить в группу'
                  className='btn--lg btn--link btn--padding-lr0'
                  action={this.changeVisibillityModalAddUsersToGroups}
                />
              )}
              <Button
                title={this.buttonText}
                className='btn--lg btn--primary'
                action={this.action}
              />
            </div>
          </div>
        </div>

        {isOpenModalAddUsersToGroups && (
          <ModalAddUsersToGroups
            user={user}
            closeModal={this.changeVisibillityModalAddUsersToGroups}
          />
        )}
      </>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUsers: data => dispatch(actions.users.fetchUsers(data)),
    createUser: data => dispatch(actions.users.createUser(data)),
    addUserPhoto: data => dispatch(actions.users.addUserPhoto(data)),
    removeUserPhoto: data => dispatch(actions.users.removeUserPhoto(data)),
    removeGroup: data => dispatch(actions.groups.removeGroup(data)),
    fetchGroups: data => dispatch(actions.groups.fetchGroups(data)),
  }
}

export default connect(null, mapDispatchToProps)(ModalCardUser)
